import {PageManager} from '@mvps-genesis/core';
import forgotPassword from 'Extensions/forgot-password';

export default class LOGN extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		const self = this;

		forgotPassword();

	}

}
